import React from 'react';

const ProductionModule = () => {
  return <div>ProductionModule</div>;
};

export default ProductionModule;
